import React from 'react';

export const InterviewsPendingIcon: React.FC = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_8570)">
      <path
        d="M5 0C5.69141 0 6.25 0.558594 6.25 1.25V2.5H11.25V1.25C11.25 0.558594 11.8086 0 12.5 0C13.1914 0 13.75 0.558594 13.75 1.25V2.5H15.625C16.6602 2.5 17.5 3.33984 17.5 4.375V6.25H0V4.375C0 3.33984 0.839844 2.5 1.875 2.5H3.75V1.25C3.75 0.558594 4.30859 0 5 0ZM0 7.5H17.5V18.125C17.5 19.1602 16.6602 20 15.625 20H1.875C0.839844 20 0 19.1602 0 18.125V7.5ZM12.8516 11.9141C13.2188 11.5469 13.2188 10.9531 12.8516 10.5898C12.4844 10.2266 11.8906 10.2227 11.5273 10.5898L7.81641 14.3008L5.98047 12.4648C5.61328 12.0977 5.01953 12.0977 4.65625 12.4648C4.29297 12.832 4.28906 13.4258 4.65625 13.7891L7.15625 16.2891C7.52344 16.6562 8.11719 16.6562 8.48047 16.2891L12.8516 11.9141Z"
        fill="#CA8A03"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_8570">
        <path d="M0 0H17.5V20H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TotalHiresIcon: React.FC = () => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_8590)">
      <path
        d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V16.7461C14.8945 16.7891 14.7891 16.8242 14.6797 16.8516L12.332 17.4375C12.2148 17.4648 12.0977 17.4844 11.9805 17.4922C11.9453 17.4961 11.9102 17.5 11.875 17.5H9.375C9.13672 17.5 8.92188 17.3672 8.81641 17.1562L8.47266 16.4648C8.40625 16.332 8.27344 16.25 8.12891 16.25C7.98438 16.25 7.84766 16.332 7.78516 16.4648L7.44141 17.1562C7.32812 17.3867 7.08203 17.5234 6.82812 17.5C6.57422 17.4766 6.35547 17.3008 6.28516 17.0586L5.625 14.8828L5.24219 16.1641C5.00391 16.957 4.27344 17.5 3.44531 17.5H3.125C2.78125 17.5 2.5 17.2188 2.5 16.875C2.5 16.5312 2.78125 16.25 3.125 16.25H3.44531C3.72266 16.25 3.96484 16.0703 4.04297 15.8047L4.625 13.8711C4.75781 13.4297 5.16406 13.125 5.625 13.125C6.08594 13.125 6.49219 13.4297 6.625 13.8711L7.07812 15.3789C7.36719 15.1367 7.73438 15 8.125 15C8.74609 15 9.3125 15.3516 9.58984 15.9062L9.76172 16.25H10.1094C9.98828 15.9062 9.96484 15.5312 10.0547 15.1641L10.6406 12.8164C10.75 12.375 10.9766 11.9766 11.2969 11.6562L15 7.95312V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM21.4766 5.45703C20.8672 4.84766 19.8789 4.84766 19.2656 5.45703L18.1172 6.60547L20.8906 9.37891L22.0391 8.23047C22.6484 7.62109 22.6484 6.63281 22.0391 6.01953L21.4766 5.45703ZM12.1836 12.5391C12.0234 12.6992 11.9102 12.8984 11.8555 13.1211L11.2695 15.4688C11.2148 15.6836 11.2773 15.9062 11.4336 16.0625C11.5898 16.2188 11.8125 16.2812 12.0273 16.2266L14.375 15.6406C14.5938 15.5859 14.7969 15.4727 14.957 15.3125L20.0039 10.2617L17.2305 7.48828L12.1836 12.5391Z"
        fill="#0056B3"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_8590">
        <path d="M0 0H22.5V20H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ActiveJobsIcon: React.FC = () => (
  <svg
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_8530)">
      <path
        d="M5.625 0C6.4538 0 7.24866 0.32924 7.83471 0.915291C8.42076 1.50134 8.75 2.2962 8.75 3.125C8.75 3.9538 8.42076 4.74866 7.83471 5.33471C7.24866 5.92076 6.4538 6.25 5.625 6.25C4.7962 6.25 4.00134 5.92076 3.41529 5.33471C2.82924 4.74866 2.5 3.9538 2.5 3.125C2.5 2.2962 2.82924 1.50134 3.41529 0.915291C4.00134 0.32924 4.7962 0 5.625 0ZM20 0C20.8288 0 21.6237 0.32924 22.2097 0.915291C22.7958 1.50134 23.125 2.2962 23.125 3.125C23.125 3.9538 22.7958 4.74866 22.2097 5.33471C21.6237 5.92076 20.8288 6.25 20 6.25C19.1712 6.25 18.3763 5.92076 17.7903 5.33471C17.2042 4.74866 16.875 3.9538 16.875 3.125C16.875 2.2962 17.2042 1.50134 17.7903 0.915291C18.3763 0.32924 19.1712 0 20 0ZM0 11.668C0 9.36719 1.86719 7.5 4.16797 7.5H5.83594C6.45703 7.5 7.04688 7.63672 7.57812 7.87891C7.52734 8.16016 7.50391 8.45312 7.50391 8.75C7.50391 10.2422 8.16016 11.582 9.19531 12.5C9.1875 12.5 9.17969 12.5 9.16797 12.5H0.832031C0.375 12.5 0 12.125 0 11.668ZM15.832 12.5C15.8242 12.5 15.8164 12.5 15.8047 12.5C16.8438 11.582 17.4961 10.2422 17.4961 8.75C17.4961 8.45312 17.4688 8.16406 17.4219 7.87891C17.9531 7.63281 18.543 7.5 19.1641 7.5H20.832C23.1328 7.5 25 9.36719 25 11.668C25 12.1289 24.625 12.5 24.168 12.5H15.832ZM8.75 8.75C8.75 7.75544 9.14509 6.80161 9.84835 6.09835C10.5516 5.39509 11.5054 5 12.5 5C13.4946 5 14.4484 5.39509 15.1517 6.09835C15.8549 6.80161 16.25 7.75544 16.25 8.75C16.25 9.74456 15.8549 10.6984 15.1517 11.4017C14.4484 12.1049 13.4946 12.5 12.5 12.5C11.5054 12.5 10.5516 12.1049 9.84835 11.4017C9.14509 10.6984 8.75 9.74456 8.75 8.75ZM5 18.957C5 16.082 7.33203 13.75 10.207 13.75H14.793C17.668 13.75 20 16.082 20 18.957C20 19.5312 19.5352 20 18.957 20H6.04297C5.46875 20 5 19.5352 5 18.957Z"
        fill="#4F47E6"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_8530">
        <path d="M0 0H25V20H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NewApplicantsIcon: React.FC = () => (
  <svg
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_8550)">
      <path
        d="M3.75 5C3.75 3.67392 4.27678 2.40215 5.21447 1.46447C6.15215 0.526784 7.42392 0 8.75 0C10.0761 0 11.3479 0.526784 12.2855 1.46447C13.2232 2.40215 13.75 3.67392 13.75 5C13.75 6.32608 13.2232 7.59785 12.2855 8.53553C11.3479 9.47322 10.0761 10 8.75 10C7.42392 10 6.15215 9.47322 5.21447 8.53553C4.27678 7.59785 3.75 6.32608 3.75 5ZM0 18.8398C0 14.9922 3.11719 11.875 6.96484 11.875H10.5352C14.3828 11.875 17.5 14.9922 17.5 18.8398C17.5 19.4805 16.9805 20 16.3398 20H1.16016C0.519531 20 0 19.4805 0 18.8398ZM19.6875 12.1875V9.6875H17.1875C16.668 9.6875 16.25 9.26953 16.25 8.75C16.25 8.23047 16.668 7.8125 17.1875 7.8125H19.6875V5.3125C19.6875 4.79297 20.1055 4.375 20.625 4.375C21.1445 4.375 21.5625 4.79297 21.5625 5.3125V7.8125H24.0625C24.582 7.8125 25 8.23047 25 8.75C25 9.26953 24.582 9.6875 24.0625 9.6875H21.5625V12.1875C21.5625 12.707 21.1445 13.125 20.625 13.125C20.1055 13.125 19.6875 12.707 19.6875 12.1875Z"
        fill="#17A34A"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_8550">
        <path d="M0 0H25V20H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PauseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.3064 7.01444C16.8979 7.87985 16.8979 10.1201 15.3064 10.9856L5.69746 16.2109C4.15077 17.052 2.25 15.9572 2.25 14.2253L2.25 3.77467C2.25 2.04276 4.15076 0.948017 5.69746 1.78911L15.3064 7.01444Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

PauseIcon.defaultProps = {
  className: '',
};

export const PlayIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_24681_11057)">
      <path
        d="M1.5 4.5C1.5 3.08579 1.5 2.37868 1.93934 1.93934C2.37868 1.5 3.08579 1.5 4.5 1.5C5.91421 1.5 6.62132 1.5 7.06066 1.93934C7.5 2.37868 7.5 3.08579 7.5 4.5V13.5C7.5 14.9142 7.5 15.6213 7.06066 16.0607C6.62132 16.5 5.91421 16.5 4.5 16.5C3.08579 16.5 2.37868 16.5 1.93934 16.0607C1.5 15.6213 1.5 14.9142 1.5 13.5V4.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10.5 4.5C10.5 3.08579 10.5 2.37868 10.9393 1.93934C11.3787 1.5 12.0858 1.5 13.5 1.5C14.9142 1.5 15.6213 1.5 16.0607 1.93934C16.5 2.37868 16.5 3.08579 16.5 4.5V13.5C16.5 14.9142 16.5 15.6213 16.0607 16.0607C15.6213 16.5 14.9142 16.5 13.5 16.5C12.0858 16.5 11.3787 16.5 10.9393 16.0607C10.5 15.6213 10.5 14.9142 10.5 13.5V4.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_11057">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
PlayIcon.defaultProps = {
  className: '',
};
export const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_24681_11054)">
      <circle cx="9" cy="9" r="7.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M6 9C6 7.58579 6 6.87868 6.43934 6.43934C6.87868 6 7.58579 6 9 6C10.4142 6 11.1213 6 11.5607 6.43934C12 6.87868 12 7.58579 12 9C12 10.4142 12 11.1213 11.5607 11.5607C11.1213 12 10.4142 12 9 12C7.58579 12 6.87868 12 6.43934 11.5607C6 11.1213 6 10.4142 6 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_11054">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
CloseIcon.defaultProps = {
  className: '',
};
export const EyeIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 3.34471C7.43364 3.12726 8.18282 3 9 3C12.1364 3 14.271 4.87467 15.5438 6.52825C16.1813 7.35639 16.5 7.77047 16.5 9C16.5 10.2295 16.1813 10.6436 15.5438 11.4718C14.271 13.1253 12.1364 15 9 15C5.86359 15 3.72897 13.1253 2.45617 11.4718C1.81872 10.6436 1.5 10.2295 1.5 9C1.5 7.77047 1.81872 7.3564 2.45617 6.52825C2.81709 6.05936 3.2473 5.57269 3.75 5.11603"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C10.2426 6.75 11.25 7.75736 11.25 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const SortIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.25889 18.7878L3.65723 14.1953"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25879 3.21094V18.7943"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7412 3.21094L18.3429 7.80344"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7412 18.7943V3.21094"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SortIcon.defaultProps = {
  className: '',
};

export const FilterIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22 7L2 7"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19 12L5 12"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M16 17H8" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

FilterIcon.defaultProps = {
  className: '',
};
// eslint-disable-next-line react/require-default-props
export const ChevronDownIcon: React.FC<{ width?: string; height?: string }> = ({
  width = '11px',
  height = '7px',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.54391 6.06819C5.47191 6.10419 5.33991 6.12219 5.14791 6.12219C4.96791 6.12219 4.80591 6.10419 4.66191 6.06819C4.56591 5.97219 4.03791 5.40819 3.07791 4.37619C2.11791 3.34419 1.53591 2.70819 1.33191 2.46819C0.875906 1.94019 0.431906 1.35819 -9.37656e-05 0.722188L0.791906 0.00218751C2.99991 2.28219 4.19991 3.52419 4.39191 3.72819C4.58391 3.94419 4.83591 4.24419 5.14791 4.62819C5.25591 4.48419 5.42991 4.28019 5.66991 4.01619L9.52191 0.00218751L10.3139 0.722188C9.89391 1.38219 9.51591 1.89219 9.17991 2.25219C8.84391 2.62419 8.18391 3.32019 7.19991 4.34019C6.21591 5.37219 5.66391 5.94819 5.54391 6.06819Z"
      fill="currentColor"
    />
  </svg>
);

export const ClearIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M9 12H0V0H9V12Z" />
    <path
      d="M8.02949 3.53145C8.32246 3.23848 8.32246 2.7627 8.02949 2.46973C7.73652 2.17676 7.26074 2.17676 6.96777 2.46973L4.4998 4.94004L2.02949 2.47207C1.73652 2.1791 1.26074 2.1791 0.967773 2.47207C0.674805 2.76504 0.674805 3.24082 0.967773 3.53379L3.43809 6.00176L0.970117 8.47207C0.677148 8.76504 0.677148 9.24082 0.970117 9.53379C1.26309 9.82676 1.73887 9.82676 2.03184 9.53379L4.4998 7.06348L6.97012 9.53145C7.26309 9.82441 7.73887 9.82441 8.03184 9.53145C8.32481 9.23848 8.32481 8.7627 8.03184 8.46973L5.56152 6.00176L8.02949 3.53145Z"
      fill="currentColor"
    />
  </svg>
);

ClearIcon.defaultProps = {
  className: '',
};

export const EllipsisIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17Z"
      fill="currentColor"
    />
    <path
      d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
      fill="currentColor"
    />
    <path
      d="M12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3Z"
      fill="currentColor"
    />
  </svg>
);

export const ShareIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.1426 2C15.8779 2 17.25 3.36368 17.25 5C17.25 6.63632 15.8779 8 14.1426 8C13.2962 7.99993 12.5352 7.677 11.9814 7.1543L11.6055 6.79883L11.1396 7.02441L7.3584 8.86035L6.87207 9.09668L6.94238 9.63281C6.95731 9.74603 6.96387 9.86521 6.96387 10C6.96387 10.1348 6.95731 10.254 6.94238 10.3672L6.87207 10.9033L7.3584 11.1396L11.1396 12.9756L11.6055 13.2012L11.9814 12.8457C12.5352 12.323 13.2962 12.0001 14.1426 12C15.8779 12 17.25 13.3637 17.25 15C17.25 16.6363 15.8779 18 14.1426 18C12.4074 17.9999 11.0361 16.6362 11.0361 15C11.0361 14.8652 11.0427 14.746 11.0576 14.6328L11.1279 14.0967L10.6416 13.8604L6.86035 12.0244L6.39453 11.7988L6.01855 12.1543C5.46479 12.677 4.7038 12.9999 3.85742 13C2.12211 13 0.75 11.6363 0.75 10C0.75 8.36368 2.12211 7 3.85742 7C4.7038 7.00007 5.46479 7.323 6.01855 7.8457L6.39453 8.20117L6.86035 7.97559L10.6416 6.13965L11.1279 5.90332L11.0576 5.36719C11.0427 5.25429 11.0361 5.13129 11.0361 5C11.0361 3.36376 12.4074 2.00015 14.1426 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

ShareIcon.defaultProps = {
  className: '',
};

export const DetailsIcon: React.FC = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_8995)">
      <path
        d="M2 14.5C1.725 14.5 1.5 14.275 1.5 14V2C1.5 1.725 1.725 1.5 2 1.5H7V4C7 4.55312 7.44688 5 8 5H10.5V14C10.5 14.275 10.275 14.5 10 14.5H2ZM2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V4.82812C12 4.29688 11.7906 3.7875 11.4156 3.4125L8.58438 0.584375C8.20938 0.209375 7.70312 0 7.17188 0H2ZM3.75 8C3.33437 8 3 8.33438 3 8.75C3 9.16562 3.33437 9.5 3.75 9.5H8.25C8.66562 9.5 9 9.16562 9 8.75C9 8.33438 8.66562 8 8.25 8H3.75ZM3.75 11C3.33437 11 3 11.3344 3 11.75C3 12.1656 3.33437 12.5 3.75 12.5H8.25C8.66562 12.5 9 12.1656 9 11.75C9 11.3344 8.66562 11 8.25 11H3.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_8995">
        <path d="M0 0H12V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ArrowRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 16" fill="none">
    <path d="M14 16H0V0H14V16Z" />
    <path
      d="M13.7063 8.70469C14.0969 8.31406 14.0969 7.67969 13.7063 7.28906L8.70625 2.28906C8.31563 1.89844 7.68125 1.89844 7.29063 2.28906C6.9 2.67969 6.9 3.31406 7.29063 3.70469L10.5875 6.99844H1C0.446875 6.99844 0 7.44531 0 7.99844C0 8.55156 0.446875 8.99844 1 8.99844H10.5844L7.29375 12.2922C6.90312 12.6828 6.90312 13.3172 7.29375 13.7078C7.68437 14.0984 8.31875 14.0984 8.70938 13.7078L13.7094 8.70781L13.7063 8.70469Z"
      fill="currentColor"
    />
  </svg>
);

export const BackArrowIcon = () => (
  <svg width="13" height="14" viewBox="0 0 13 14" fill="none">
    <path
      d="M0.256348 6.38018C-0.0854492 6.72197 -0.0854492 7.27705 0.256348 7.61885L4.63135 11.9938C4.97314 12.3356 5.52822 12.3356 5.87002 11.9938C6.21182 11.6521 6.21182 11.097 5.87002 10.7552L2.98525 7.87315H11.3743C11.8583 7.87315 12.2493 7.48213 12.2493 6.99814C12.2493 6.51416 11.8583 6.12314 11.3743 6.12314H2.98799L5.86729 3.24111C6.20908 2.89932 6.20908 2.34424 5.86729 2.00244C5.52549 1.66064 4.97041 1.66064 4.62861 2.00244L0.253613 6.37744L0.256348 6.38018Z"
      fill="currentColor"
    />
  </svg>
);

export const FilterIcon2 = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24886_4327)">
      <path
        d="M0 13C0 13.5531 0.446875 14 1 14H2.70937C3.09375 14.8844 3.975 15.5 5 15.5C6.025 15.5 6.90625 14.8844 7.29063 14H15C15.5531 14 16 13.5531 16 13C16 12.4469 15.5531 12 15 12H7.29063C6.90625 11.1156 6.025 10.5 5 10.5C3.975 10.5 3.09375 11.1156 2.70937 12H1C0.446875 12 0 12.4469 0 13ZM4 13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12C5.26522 12 5.51957 12.1054 5.70711 12.2929C5.89464 12.4804 6 12.7348 6 13C6 13.2652 5.89464 13.5196 5.70711 13.7071C5.51957 13.8946 5.26522 14 5 14C4.73478 14 4.48043 13.8946 4.29289 13.7071C4.10536 13.5196 4 13.2652 4 13ZM10 8C10 7.73478 10.1054 7.48043 10.2929 7.29289C10.4804 7.10536 10.7348 7 11 7C11.2652 7 11.5196 7.10536 11.7071 7.29289C11.8946 7.48043 12 7.73478 12 8C12 8.26522 11.8946 8.51957 11.7071 8.70711C11.5196 8.89464 11.2652 9 11 9C10.7348 9 10.4804 8.89464 10.2929 8.70711C10.1054 8.51957 10 8.26522 10 8ZM11 5.5C9.975 5.5 9.09375 6.11562 8.70938 7H1C0.446875 7 0 7.44688 0 8C0 8.55313 0.446875 9 1 9H8.70938C9.09375 9.88437 9.975 10.5 11 10.5C12.025 10.5 12.9062 9.88437 13.2906 9H15C15.5531 9 16 8.55313 16 8C16 7.44688 15.5531 7 15 7H13.2906C12.9062 6.11562 12.025 5.5 11 5.5ZM6 4C5.73478 4 5.48043 3.89464 5.29289 3.70711C5.10536 3.51957 5 3.26522 5 3C5 2.73478 5.10536 2.48043 5.29289 2.29289C5.48043 2.10536 5.73478 2 6 2C6.26522 2 6.51957 2.10536 6.70711 2.29289C6.89464 2.48043 7 2.73478 7 3C7 3.26522 6.89464 3.51957 6.70711 3.70711C6.51957 3.89464 6.26522 4 6 4ZM8.29062 2C7.90625 1.11563 7.025 0.5 6 0.5C4.975 0.5 4.09375 1.11563 3.70937 2H1C0.446875 2 0 2.44687 0 3C0 3.55312 0.446875 4 1 4H3.70937C4.09375 4.88438 4.975 5.5 6 5.5C7.025 5.5 7.90625 4.88438 8.29062 4H15C15.5531 4 16 3.55312 16 3C16 2.44687 15.5531 2 15 2H8.29062Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24886_4327">
        <path d="M0 0H16V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkedinIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8Z"
      fill="currentColor"
    />
    <path
      d="M6.3093 4.84608C6.3093 5.31335 5.90425 5.69215 5.40465 5.69215C4.90502 5.69215 4.5 5.31335 4.5 4.84608C4.5 4.3788 4.90502 4 5.40465 4C5.90425 4 6.3093 4.3788 6.3093 4.84608Z"
      fill="white"
    />
    <path d="M4.62305 6.3125H6.16944V10.9984H4.62305V6.3125Z" fill="white" />
    <path
      d="M8.65968 6.31275H7.11328V10.9987H8.65968C8.65968 10.9987 8.65968 9.5235 8.65968 8.60115C8.65968 8.0475 8.84873 7.49145 9.60298 7.49145C10.4554 7.49145 10.4503 8.21595 10.4463 8.77725C10.4411 9.5109 10.4535 10.2596 10.4535 10.9987H11.9999V8.52555C11.9868 6.9464 11.5753 6.21875 10.2215 6.21875C9.41758 6.21875 8.91923 6.58375 8.65968 6.91395V6.31275Z"
      fill="white"
    />
  </svg>
);

export const LocationIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
  >
    <g clipPath="url(#clip0_24681_9495)">
      <path
        d="M6.74062 15.6C8.34375 13.5938 12 8.73125 12 6C12 2.6875 9.3125 0 6 0C2.6875 0 0 2.6875 0 6C0 8.73125 3.65625 13.5938 5.25938 15.6C5.64375 16.0781 6.35625 16.0781 6.74062 15.6ZM6 4C6.53043 4 7.03914 4.21071 7.41421 4.58579C7.78929 4.96086 8 5.46957 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_9495">
        <path d="M0 0H12V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CompanyIcon: React.FC = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6847 3.92851C15.9375 4.26481 15.9375 4.73296 15.9375 5.66927V14.1693H16.3125C16.6232 14.1693 16.875 14.3931 16.875 14.6693C16.875 14.9454 16.6232 15.1693 16.3125 15.1693H1.3125C1.00184 15.1693 0.75 14.9454 0.75 14.6693C0.75 14.3931 1.00184 14.1693 1.3125 14.1693H1.6875V5.66927C1.6875 4.73296 1.6875 4.26481 1.9403 3.92851C2.04973 3.78292 2.19036 3.65792 2.35414 3.56064C2.68506 3.3641 3.12947 3.33947 3.94052 3.33638C3.93744 3.53064 3.93747 3.73363 3.93749 3.94294L3.9375 4.0026V4.83594H3.1875C2.87684 4.83594 2.625 5.05979 2.625 5.33594C2.625 5.61208 2.87684 5.83594 3.1875 5.83594H3.9375V6.83594H3.1875C2.87684 6.83594 2.625 7.05979 2.625 7.33594C2.625 7.61208 2.87684 7.83594 3.1875 7.83594H3.9375V8.83594H3.1875C2.87684 8.83594 2.625 9.05979 2.625 9.33594C2.625 9.61208 2.87684 9.83594 3.1875 9.83594H3.9375V14.1693H5.0625V4.0026C5.0625 2.74553 5.0625 2.11699 5.50184 1.72646C5.94118 1.33594 6.64829 1.33594 8.0625 1.33594H9.5625C10.9767 1.33594 11.6838 1.33594 12.1232 1.72646C12.5625 2.11699 12.5625 2.74553 12.5625 4.0026V14.1693H13.6875V9.83594H14.4375C14.7482 9.83594 15 9.61208 15 9.33594C15 9.05979 14.7482 8.83594 14.4375 8.83594H13.6875V7.83594H14.4375C14.7482 7.83594 15 7.61208 15 7.33594C15 7.05979 14.7482 6.83594 14.4375 6.83594H13.6875V5.83594H14.4375C14.7482 5.83594 15 5.61208 15 5.33594C15 5.05979 14.7482 4.83594 14.4375 4.83594H13.6875V4.0026L13.6875 3.94295C13.6875 3.73364 13.6876 3.53064 13.6845 3.33638C14.4955 3.33947 14.9399 3.3641 15.2709 3.56064C15.4346 3.65792 15.5753 3.78292 15.6847 3.92851ZM9.375 12.6693C9.375 12.3931 9.12316 12.1693 8.8125 12.1693C8.50184 12.1693 8.25 12.3931 8.25 12.6693V14.1693H9.375V12.6693ZM6.75 10.0026C6.75 9.72646 7.00184 9.5026 7.3125 9.5026H10.3125C10.6232 9.5026 10.875 9.72646 10.875 10.0026C10.875 10.2787 10.6232 10.5026 10.3125 10.5026H7.3125C7.00184 10.5026 6.75 10.2787 6.75 10.0026ZM7.3125 7.5026C7.00184 7.5026 6.75 7.72646 6.75 8.0026C6.75 8.27875 7.00184 8.5026 7.3125 8.5026H10.3125C10.6232 8.5026 10.875 8.27875 10.875 8.0026C10.875 7.72646 10.6232 7.5026 10.3125 7.5026H7.3125ZM6.9375 4.66927C6.9375 3.65675 7.86091 2.83594 9 2.83594C10.1391 2.83594 11.0625 3.65675 11.0625 4.66927C11.0625 5.68179 10.1391 6.5026 9 6.5026C7.86091 6.5026 6.9375 5.68179 6.9375 4.66927ZM8.0625 4.66927C8.0625 4.20903 8.48223 3.83594 9 3.83594C9.51777 3.83594 9.9375 4.20903 9.9375 4.66927C9.9375 5.12951 9.51777 5.5026 9 5.5026C8.48223 5.5026 8.0625 5.12951 8.0625 4.66927Z"
      fill="currentColor"
    />
  </svg>
);

export const DepartmentIcon: React.FC = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_9504)">
      <path
        d="M1.5 0C0.671875 0 0 0.671875 0 1.5V14.5C0 15.3281 0.671875 16 1.5 16H4.5V13.5C4.5 12.6719 5.17188 12 6 12C6.82812 12 7.5 12.6719 7.5 13.5V16H10.5C11.3281 16 12 15.3281 12 14.5V1.5C12 0.671875 11.3281 0 10.5 0H1.5ZM2 7.5C2 7.225 2.225 7 2.5 7H3.5C3.775 7 4 7.225 4 7.5V8.5C4 8.775 3.775 9 3.5 9H2.5C2.225 9 2 8.775 2 8.5V7.5ZM5.5 7H6.5C6.775 7 7 7.225 7 7.5V8.5C7 8.775 6.775 9 6.5 9H5.5C5.225 9 5 8.775 5 8.5V7.5C5 7.225 5.225 7 5.5 7ZM8 7.5C8 7.225 8.225 7 8.5 7H9.5C9.775 7 10 7.225 10 7.5V8.5C10 8.775 9.775 9 9.5 9H8.5C8.225 9 8 8.775 8 8.5V7.5ZM2.5 3H3.5C3.775 3 4 3.225 4 3.5V4.5C4 4.775 3.775 5 3.5 5H2.5C2.225 5 2 4.775 2 4.5V3.5C2 3.225 2.225 3 2.5 3ZM5 3.5C5 3.225 5.225 3 5.5 3H6.5C6.775 3 7 3.225 7 3.5V4.5C7 4.775 6.775 5 6.5 5H5.5C5.225 5 5 4.775 5 4.5V3.5ZM8.5 3H9.5C9.775 3 10 3.225 10 3.5V4.5C10 4.775 9.775 5 9.5 5H8.5C8.225 5 8 4.775 8 4.5V3.5C8 3.225 8.225 3 8.5 3Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_9504">
        <path d="M0 0H12V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SalaryRangeIcon: React.FC = () => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_9519)">
      <path
        d="M5.00005 0C5.55317 0 6.00005 0.446875 6.00005 1V2.11562C6.05005 2.12187 6.09692 2.12812 6.14692 2.1375C6.15942 2.14062 6.1688 2.14062 6.1813 2.14375L7.6813 2.41875C8.22505 2.51875 8.58442 3.04063 8.48442 3.58125C8.38442 4.12187 7.86255 4.48438 7.32192 4.38438L5.83755 4.1125C4.85942 3.96875 3.99692 4.06563 3.39067 4.30625C2.78442 4.54688 2.54067 4.87812 2.48442 5.18437C2.42192 5.51875 2.4688 5.70625 2.52192 5.82188C2.57817 5.94375 2.69379 6.08125 2.92192 6.23438C3.43129 6.56875 4.21255 6.7875 5.22505 7.05625L5.31567 7.08125C6.20942 7.31875 7.30317 7.60625 8.11567 8.1375C8.55942 8.42812 8.97817 8.82187 9.23755 9.37187C9.50317 9.93125 9.55942 10.5563 9.43754 11.2219C9.22192 12.4094 8.40317 13.2031 7.38755 13.6187C6.95942 13.7937 6.4938 13.9062 6.00005 13.9625V15C6.00005 15.5531 5.55317 16 5.00005 16C4.44692 16 4.00005 15.5531 4.00005 15V13.9094C3.98755 13.9062 3.97192 13.9062 3.95942 13.9031H3.95317C3.19067 13.7844 1.93755 13.4563 1.0938 13.0813C0.59067 12.8562 0.362545 12.2656 0.587545 11.7625C0.812545 11.2594 1.40317 11.0312 1.9063 11.2563C2.55942 11.5469 3.63442 11.8344 4.25629 11.9312C5.25317 12.0781 6.07505 11.9937 6.6313 11.7656C7.15942 11.55 7.40005 11.2375 7.4688 10.8625C7.52817 10.5312 7.4813 10.3406 7.42817 10.225C7.3688 10.1 7.25317 9.9625 7.02192 9.80937C6.50942 9.475 5.72505 9.25625 4.70942 8.9875L4.62192 8.96562C3.7313 8.72812 2.63755 8.4375 1.82505 7.90625C1.3813 7.61562 0.96567 7.21875 0.706295 6.66875C0.443795 6.10938 0.39067 5.48438 0.51567 4.81875C0.74067 3.625 1.63442 2.85 2.65005 2.44688C3.06567 2.28125 3.52192 2.16875 4.00005 2.10313V1C4.00005 0.446875 4.44692 0 5.00005 0Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_9519">
        <path d="M0 0H10V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const JobTypeIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_24681_9537)">
      <path
        d="M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM7.25 3.75V8C7.25 8.25 7.375 8.48438 7.58437 8.625L10.5844 10.625C10.9281 10.8562 11.3938 10.7625 11.625 10.4156C11.8562 10.0687 11.7625 9.60625 11.4156 9.375L8.75 7.6V3.75C8.75 3.33437 8.41562 3 8 3C7.58437 3 7.25 3.33437 7.25 3.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_24681_9537">
        <path d="M0 0H16V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SuitcaseIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 16H0V0H16V16Z" stroke="#E5E7EB" />
    <path
      d="M5.75 1.5H10.25C10.3875 1.5 10.5 1.6125 10.5 1.75V3H5.5V1.75C5.5 1.6125 5.6125 1.5 5.75 1.5ZM4 1.75V3H2C0.896875 3 0 3.89687 0 5V8H6H10H16V5C16 3.89687 15.1031 3 14 3H12V1.75C12 0.784375 11.2156 0 10.25 0H5.75C4.78438 0 4 0.784375 4 1.75ZM16 9H10V10C10 10.5531 9.55313 11 9 11H7C6.44688 11 6 10.5531 6 10V9H0V13C0 14.1031 0.896875 15 2 15H14C15.1031 15 16 14.1031 16 13V9Z"
      fill="currentColor"
    />
  </svg>
);

export const EditIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33398 12.8359H11.6673"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.10202 2.1341L8.53456 1.70156C9.25122 0.984897 10.4132 0.984897 11.1298 1.70156C11.8465 2.41822 11.8465 3.58016 11.1298 4.29682L10.6973 4.72937M8.10202 2.1341C8.10202 2.1341 8.15608 3.05326 8.9671 3.86428C9.77812 4.6753 10.6973 4.72937 10.6973 4.72937M8.10202 2.1341L4.12544 6.11068C3.85609 6.38002 3.72142 6.5147 3.6056 6.66319C3.46898 6.83835 3.35185 7.02787 3.25628 7.22841C3.17526 7.3984 3.11503 7.57908 2.99458 7.94045L2.48416 9.4717M10.6973 4.72937L6.7207 8.70594C6.45136 8.97529 6.31668 9.10996 6.16819 9.22578C5.99303 9.3624 5.80351 9.47953 5.60297 9.5751C5.43298 9.65612 5.2523 9.71635 4.89093 9.8368L3.35968 10.3472M3.35968 10.3472L2.98538 10.472C2.80755 10.5313 2.61149 10.485 2.47895 10.3524C2.3464 10.2199 2.30012 10.0238 2.35939 9.846L2.48416 9.4717M3.35968 10.3472L2.48416 9.4717"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const SaveIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33398 12.8359H11.6673"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.10202 2.1341L8.53456 1.70156C9.25122 0.984897 10.4132 0.984897 11.1298 1.70156C11.8465 2.41822 11.8465 3.58016 11.1298 4.29682L10.6973 4.72937M8.10202 2.1341C8.10202 2.1341 8.15608 3.05326 8.9671 3.86428C9.77812 4.6753 10.6973 4.72937 10.6973 4.72937M8.10202 2.1341L4.12544 6.11068C3.85609 6.38002 3.72142 6.5147 3.6056 6.66319C3.46898 6.83835 3.35185 7.02787 3.25628 7.22841C3.17526 7.3984 3.11503 7.57908 2.99458 7.94045L2.48416 9.4717M10.6973 4.72937L6.7207 8.70594C6.45136 8.97529 6.31668 9.10996 6.16819 9.22578C5.99303 9.3624 5.80351 9.47953 5.60297 9.5751C5.43298 9.65612 5.2523 9.71635 4.89093 9.8368L3.35968 10.3472M3.35968 10.3472L2.98538 10.472C2.80755 10.5313 2.61149 10.485 2.47895 10.3524C2.3464 10.2199 2.30012 10.0238 2.35939 9.846L2.48416 9.4717M3.35968 10.3472L2.48416 9.4717"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const RefreshIcon: React.FC<{ className: string }> = ({
  className = '',
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.0026 14.6693C11.6845 14.6693 14.6693 11.6845 14.6693 8.0026C14.6693 4.32071 11.6845 1.33594 8.0026 1.33594C4.32071 1.33594 1.33594 4.32071 1.33594 8.0026C1.33594 11.6845 4.32071 14.6693 8.0026 14.6693Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33594 9.672C5.45594 9.872 5.6026 10.0587 5.76927 10.2253C6.99593 11.452 8.98926 11.452 10.2226 10.2253C10.7226 9.72534 11.0093 9.09198 11.1026 8.44531"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.89062 7.55159C4.98396 6.89826 5.27063 6.27156 5.77063 5.77156C6.9973 4.5449 8.99063 4.5449 10.224 5.77156C10.3973 5.9449 10.5373 6.13157 10.6573 6.32491"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.21094 11.4519V9.67188H6.99093"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7878 4.54688V6.32686H9.00781"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
